import React from 'react'
import styled from 'styled-components'

const Loading = ({ center }) => {
    return (
        <Loader center={center}>
            <div className='loader_text'>
            </div>
        </Loader>
    )
}

const Loader = styled.div`
    .loader_text {
        position: absolute;
        display:flex ;
        color:white;
        font-size:1.3rem ;
        justify-content:flex-start ;
        align-items:${(prop) => prop.center ? 'center' : 'flex-start'};
        top: 0;
        bottom:0 ;
        left: 0;
        right: 0;
        width: 4rem;
        margin: auto; 
    }
    .loader_text:after {
        content: "Loading";
        font-weight: bold;
        animation-name: loading-text;
        animation-duration: 3s;
        animation-iteration-count: infinite; 
    }

    @keyframes loading-text {
        0% {
            content: "Loading"; 
        }
        25% {
            content: "Loading."; 
        }
        50% {
            content: "Loading.."; 
        }
        75% {
            content: "Loading..."; 
        } 
    }

`

export default Loading